import './index.css';
import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './App.jsx';

// ViteReactSSG renders every route in `routes` to real static HTML at build
// time (via ReactDOMServer), then hydrates on the client. This is what fixes
// "pages render blank to Googlebot" — the crawler now gets fully-formed
// HTML (title, meta tags, H1, JSON-LD, content) without executing JS.
export const createRoot = ViteReactSSG({ routes });
